import React, { useState, useEffect } from 'react'
import Wrapper from '../../components/Wrapper'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Paper,
  Box,
  Typography,
  IconButton,
  Alert,
  TextField,
  Grid,
  Button,
} from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import InfoIcon from '@mui/icons-material/Info'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteIcon from '@mui/icons-material/Delete'
import { auto, global, input, menu, moneyT, ivrSingle, sip } from '../../translate'
import { toast } from 'react-toastify'
import {
  inputStyles,
  inputLabelStyles,
  sectionTitleStyles,
  buttonStyles,
} from '../../helpers/style'
import Api from '../../Api'
import SelectReact from 'react-select'
import { customStyles } from '../../helpers/style'
import AutoSelect from '../../components/AutoSelect'

const { REACT_APP_SERVER } = process.env
const color = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : '#7ebc0a'

function formatDateTimeForInput(val) {
  if (!val) return ''
  const d = new Date(val)
  if (Number.isNaN(d.getTime())) return ''
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

function toIsoFromDateTimeLocal(value) {
  if (!value) return ''
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/)
  if (!m) return ''
  const year = Number(m[1])
  const month = Number(m[2])
  const day = Number(m[3])
  const hour = Number(m[4])
  const minute = Number(m[5])
  const d = new Date(year, month - 1, day, hour, minute, 0, 0)
  if (Number.isNaN(d.getTime())) return ''
  return d.toISOString()
}

export default function ConferenceCallSingle() {
  const { id } = useParams()
  const navigate = useNavigate()
  const langIndex = +localStorage.getItem('atsLang') || 1
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    name: '',
    line: '',
    noaction: '',
    dateTime: formatDateTimeForInput(new Date()),
    time: [
      {
        id: new Date().toISOString(),
        num: '',
        phone: '',
        attempt: 2,
        okStart: 0,
        okEnd: 60,
      },
    ],
  })
  const [inBuddies, setInBuddies] = useState([])
  const [inShorts, setInShorts] = useState([])
  const [inShortsSingleItem, setInShortsSingleItem] = useState([])
  const isEdit = id && id !== 'add'

  useEffect(() => {
    fetchGetIn()
  }, [])

  useEffect(() => {
    if (isEdit) fetchSingle()
  }, [id])

  const fetchGetIn = async () => {
    try {
      const { data } = await Api.getConferenceCallIn()
      const inNum = data?.inputNumber || {}
      setInBuddies(inNum.buddies || [])
      setInShorts(inNum.shorts || [])
      setInShortsSingleItem(inNum.shortsSingleItem || [])
    } catch (error) {
      console.error('Error fetching getIn:', error)
    }
  }

  const fetchSingle = async () => {
    setLoading(true)
    try {
      const { data } = await Api.singleConferenceCall(id)
      const dataItem = data?.dataItem || {}
      const items = data?.memberGroupsItems || []
      const firstDate = items.length > 0 && items[0].lastupdated
        ? formatDateTimeForInput(items[0].lastupdated)
        : formatDateTimeForInput(new Date())
      setForm({
        name: dataItem.name ?? '',
        line: dataItem.virtual ?? '',
        noaction: dataItem.noaction != null ? String(dataItem.noaction) : '',
        dateTime: firstDate,
        time:
          items.length > 0
            ? items.map((s) => ({
                id: s.id ?? s.item_id ?? new Date().toISOString(),
                num: s.buddy != null ? String(s.buddy) : '',
                phone: s.dnumber ?? '',
                attempt: s.rlimit ?? 2,
                okStart: s.okinterval ?? 0,
                okEnd: s.nokinterval ?? 60,
              }))
            : [
                {
                  id: new Date().toISOString(),
                  num: '',
                  phone: '',
                  attempt: 2,
                  okStart: 0,
                  okEnd: 60,
                },
              ],
      })
    } catch (error) {
      console.error('Error loading conference call:', error)
      toast.error('Error loading conference call')
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleTimeChange = (index, name, value) => {
    setForm((prev) => {
      const time = [...(prev.time || [])]
      time[index] = { ...time[index], [name]: value }
      return { ...prev, time }
    })
  }

  const handleAddTime = () => {
    setForm((prev) => ({
      ...prev,
      time: [
        ...(prev.time || []),
        {
          id: new Date().toISOString(),
          num: '',
          phone: '',
          attempt: 2,
          okStart: 0,
          okEnd: 60,
        },
      ],
    }))
  }

  const handleRemoveTime = (index) => {
    setForm((prev) => ({
      ...prev,
      time: prev.time.filter((_, i) => i !== index),
    }))
  }

  const handleGoBack = () => navigate('/conference_call_list')

  const handleSave = async () => {
    if (!(form.name || '').trim()) {
      toast.error(input.required[langIndex] || 'Name is required')
      return
    }
    if (!(form.line || '').toString().trim()) {
      toast.error(input.required[langIndex] || 'Line is required')
      return
    }
    if (!form.time || form.time.length === 0) {
      toast.error(input.required[langIndex] || 'At least one time entry is required')
      return
    }
    const campaignDateTime = toIsoFromDateTimeLocal(form.dateTime) || new Date().toISOString()
    const payload = {
      name: form.name.trim(),
      line: String(form.line).trim(),
      noaction: form.noaction != null ? String(form.noaction).trim() || form.line : form.line,
      time: form.time.map((t) => ({
        id: typeof t.id === 'number' && t.id > 0 ? t.id : undefined,
        num: t.num,
        date: campaignDateTime,
        phone: t.phone || '',
        attempt: t.attempt ?? 2,
        okStart: t.okStart ?? 0,
        okEnd: t.okEnd ?? 60,
      })),
    }
    setSaving(true)
    try {
      if (isEdit) {
        await Api.editConferenceCall(payload, id)
        toast.success(global.success[langIndex] || 'Conference call updated')
      } else {
        await Api.createConferenceCall(payload)
        toast.success(global.success[langIndex] || 'Conference call created')
      }
      navigate('/conference_call_list')
    } catch (error) {
      console.error('Error saving conference call:', error)
      toast.error(error?.response?.data?.message || global.error[langIndex] || 'Error saving')
    } finally {
      setSaving(false)
    }
  }

  const noActionOptions = [
    ...(inShorts || []).map((k) => ({ value: k.name, label: k.title || k.name })),
    ...(inShortsSingleItem || []).map((k) => ({ value: k.name, label: k.title || k.name })),
  ]
  const numOptions = [
    { label: 'IVR', options: (inBuddies || []).map((k) => ({ value: k.name, label: k.title || k.name })) },
    { label: 'SHORT', options: (inShorts || []).map((k) => ({ value: k.name, label: k.title || k.name })) },
  ]

  return (
    <Wrapper>
      <div className="tableParent">
        <Paper sx={{ p: 3 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 3,
              borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
              pb: 2.5,
            }}
          >
            <IconButton size="small" sx={{ color, fontSize: 18 }} onClick={handleGoBack} aria-label="Back">
              <ArrowBackIosNewIcon sx={{ fontSize: 20, fontWeight: 700 }} />
            </IconButton>
            <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
              {isEdit ? global.edit[langIndex] : sip.add_btn[langIndex]} {menu.conferenceCall?.[langIndex] || 'Conference call'}
            </Typography>
          </Box>

          <Alert icon={<InfoIcon />} severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">{moneyT.conferenceCallDescription?.[langIndex] || 'Conference call campaigns with date-based scheduling.'}</Typography>
          </Alert>

          <Paper sx={{ p: 3, border: `1px solid ${color}` }}>
            <Typography variant="h6" sx={sectionTitleStyles}>
              {menu.conferenceCall?.[langIndex] || 'Conference call'} {global.edit[langIndex] || 'Information'}
            </Typography>
            <Grid container spacing={3} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={auto.line[langIndex]}
                  value={form.line}
                  onChange={(e) => handleChange('line', e.target.value)}
                  required
                  sx={inputStyles}
                  InputLabelProps={{ sx: inputLabelStyles }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={auto.name[langIndex]}
                  value={form.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  required
                  sx={inputStyles}
                  InputLabelProps={{ sx: inputLabelStyles }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ minWidth: 200 }}>
                  <Typography variant="caption" sx={{ ...inputLabelStyles, display: 'block', mb: 0.5 }}>
                    {ivrSingle.no_answer_short_label?.[langIndex] || 'If no answer'}
                  </Typography>
                  <SelectReact
                    styles={customStyles}
                    value={
                      noActionOptions.find((o) => o.value === form.noaction)
                        ? { value: form.noaction, label: noActionOptions.find((o) => o.value === form.noaction).label }
                        : null
                    }
                    onChange={(ev) => handleChange('noaction', ev ? ev.value : '')}
                    options={noActionOptions}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    classNamePrefix="select"
                    placeholder={input.select[langIndex]}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={langIndex === 1 ? 'Date & time' : langIndex === 2 ? 'Дата и время' : 'Ամսաթիվ և ժամ'}
                  type="datetime-local"
                  value={form.dateTime || ''}
                  onChange={(e) => handleChange('dateTime', e.target.value)}
                  InputLabelProps={{ shrink: true, sx: inputLabelStyles }}
                  sx={{
                    ...inputStyles,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: '#fafbfc',
                      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: `${color}66` },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: color, borderWidth: 2 },
                    },
                  }}
                  inputProps={{ step: 60 }}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 4 }}>
              <Typography variant="h6" sx={sectionTitleStyles}>
                {langIndex === 1 ? 'Participants' : langIndex === 2 ? 'Участники' : 'Մասնակիցներ'}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {langIndex === 1 ? 'Set participant (IVR or short) for each entry. Date & time above applies to all.' : langIndex === 2 ? 'Укажите участника для каждой записи. Выбранные дата и время применяются ко всем.' : 'Նշեք մասնակից յուրաքանչյուր գրառման համար։ Ընտրված ամսաթիվն ու ժամը կիրառվեն բոլորի նկատմամբ։'}
              </Typography>
              {(form.time || []).map((timeItem, index) => (
                <Paper
                  key={timeItem.id || index}
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    border: `1px solid ${color}26`,
                    borderRadius: 2,
                    backgroundColor: '#f9fafb',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
                    transition: 'box-shadow 200ms ease, border-color 200ms ease',
                    '&:hover': {
                      boxShadow: `0 6px 16px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)`,
                      borderColor: `${color}55`,
                    },
                  }}
                >
                  <Grid container spacing={2} alignItems="flex-start">
                    <Grid item xs={12} md={5}>
                      <Typography variant="caption" sx={{ ...inputLabelStyles, display: 'block', mb: 0.5 }}>
                        {auto.num[langIndex]}
                      </Typography>
                      <Box sx={{ '& .select__control': { minHeight: 40 } }}>
                      <SelectReact
                        styles={customStyles}
                        value={
                          timeItem.num
                            ? (() => {
                                const found = [...(inBuddies || []), ...(inShorts || [])].find((k) => k.name === timeItem.num)
                                return { value: timeItem.num, label: found?.title || timeItem.num }
                              })()
                            : null
                        }
                        onChange={(ev) => handleTimeChange(index, 'num', ev ? ev.value : '')}
                        options={numOptions}
                        formatGroupLabel={(d) => (AutoSelect ? <AutoSelect data={d} /> : d.label)}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        classNamePrefix="select"
                        placeholder={input.select[langIndex]}
                      />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label={auto.phone[langIndex]}
                        value={timeItem.phone || ''}
                        onChange={(e) => handleTimeChange(index, 'phone', e.target.value)}
                        InputLabelProps={{ sx: inputLabelStyles }}
                        sx={inputStyles}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label={auto.attempt[langIndex]}
                        type="number"
                        inputProps={{ min: 1, max: 10 }}
                        value={timeItem.attempt ?? 2}
                        onChange={(e) => handleTimeChange(index, 'attempt', parseInt(e.target.value, 10) || 2)}
                        InputLabelProps={{ sx: inputLabelStyles }}
                        sx={inputStyles}
                      />
                    </Grid>
                    <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, pt: { xs: 0.5, md: 3 } }}>
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveTime(index)}
                        disabled={form.time.length <= 1}
                        sx={{ color: '#ef4444', '&:hover': { backgroundColor: 'rgba(239,68,68,0.1)' } }}
                        aria-label="Remove"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
              <Button
                variant="outlined"
                startIcon={<AddCircleOutlineIcon />}
                onClick={handleAddTime}
                sx={{ borderColor: color, color, textTransform: 'none', '&:hover': { borderColor: color, backgroundColor: `${color}10` } }}
              >
                {sip.add_btn[langIndex]}
              </Button>
            </Box>

            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={saving || loading}
                size="small"
                sx={{
                  ...buttonStyles,
                  backgroundColor: `${color} !important`,
                  color: '#fff !important',
                  '&:hover': { backgroundColor: `${color}dd !important`, color: '#fff !important' },
                  '&:disabled': { opacity: 0.7 },
                }}
              >
                {saving ? (global.edit[langIndex] || 'Saving...') : (global.edit[langIndex] || 'Save')}
              </Button>
            </Box>
          </Paper>
        </Paper>
      </div>
    </Wrapper>
  )
}
